import { Button, ButtonGroup, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, GridList, GridListTile, GridListTileBar, IconButton } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DescriptionIcon from '@material-ui/icons/Description';
import PhotoIcon from '@material-ui/icons/Photo';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'src/utils/axios';
import { openBlob } from 'src/utils/Common';
import { deleteFotografWithId } from 'src/utils/storage/StrPhoto';

const useStyles = makeStyles((theme) => ({
  root: {},
  dropZone: {
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer'
    }
  },
  dragActive: {
    backgroundColor: colors.grey[50],
    opacity: 0.5
  },
  info: {
    marginTop: theme.spacing(1)
  },
  list: {
    maxHeight: 320
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  icon: {
    color: 'white',
  },
  image: {
    position: 'relative',
    height: 130,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  imageFull: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function FilesPreview({ className, FisNo, dataUri, files, readonly, fetchPhotos, setLoading }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const handleDetayAc = (event, dosya) => {
    if (dosya.DOSYA_ID < 0) {
      var image = new Image();
      image.src = dosya.DOSYA_DATA;
      var w = window.open("");
      w.document.write(image.outerHTML);
    } else {
      setLoading(true);
      const config = {
        responseType: 'blob',
      };
      axios.get('/ArtemisDosya/' + dosya.DOSYA_ID, config)
        .then(response => {
          openBlob(response.data, dosya.DOSYA_ADI);
          setLoading(false);
        });
    }
  };
  const handleDelete = (event, DosyaId, DosyaFisNo) => {
    confirmAlert({
      message: 'Fotoğraf Silinecektir. Onaylıyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleDeleteEvet(event, DosyaId, DosyaFisNo)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };

  const handleDeleteEvet = (event, DosyaId, DosyaFisNo) => {
    if (DosyaId < 0) {
      deleteFotografWithId(DosyaId);
      fetchPhotos(true);
    } else {
      axios.get(`/DeleteArtemisDosya/${DosyaId}/${DosyaFisNo}`)
        .then((response) => {
          const res = response.data;
          let informationAlert = res.ErrorDescription;
          setUyari(informationAlert);
          setOpen(true);
          fetchPhotos(true);
        });
    }
  };


  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {files.length > 0 && (
        <>
          <GridList cellHeight={150} className={classes.gridList}>
            {files.map((tile) => (
              <GridListTile
                key={tile.DOSYA_ID}
              >
                <IconButton
                  onClick={(event) => handleDetayAc(event, tile)} aria-label={`büyük resim ${tile.DOSYA_ADI}`}
                >
                  {
                    (tile.DOSYA_TIPI === 'image/jpeg' || tile.DOSYA_TIPI === 'image/png' || tile.DOSYA_TIPI === 'image/gif')
                      ?
                      <PhotoIcon fontSize='large' className={classes.imageFull} />
                      :
                      (
                        tile.DOSYA_TIPI === 'application/pdf' ? <PictureAsPdfIcon fontSize='large' /> : <DescriptionIcon fontSize='large' />
                      )
                  }
                </IconButton>
                <GridListTileBar
                  title={tile.DOSYA_ADI}
                  subtitle={<span>{tile.TIP + (tile.DOSYA_ID < 0 ? ' Lokal' : '')}</span>}
                  // actionIcon={
                  //   <ButtonGroup color="primary" aria-label="outlined primary button group">
                  //     <IconButton onClick={(event) => handleDelete(event, tile.DOSYA_ID, tile.DOSYA_FIS_NO)}
                  //       aria-label={`Delete ${tile.DOSYA_ADI}`}
                  //       className={classes.icon}
                  //       disabled={readonly}
                  //     >
                  //       <DeleteForeverIcon color="error" />
                  //     </IconButton>
                  //   </ButtonGroup>
                  // }
                />
              </GridListTile>
            ))}
          </GridList>

        </>
      )}
    </div>
  );
}
FilesPreview.propTypes = {
  className: PropTypes.string
};

export default FilesPreview;
